var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVirtualHubs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "virtual-hubs_svg__a",
    x1: 7.688,
    y1: -26.771,
    x2: 7.688,
    y2: -21.482,
    gradientTransform: "translate(0 32)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#5ea0ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#5b9fee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#509aeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#3f92e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#2688df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#127fd9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "virtual-hubs_svg__b",
    x1: 10.312,
    y1: -24.568,
    x2: 10.312,
    y2: -19.279,
    gradientTransform: "translate(0 32)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#50e6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#32bedd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#198ab3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "virtual-hubs_svg__c",
    x1: 9,
    y1: 5.38,
    x2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.199,
    stopColor: "#005ba1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078d4"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.736 5.229H6.62a2.644 2.644 0 00-.41 5.253 2.824 2.824 0 01.027-.982 1.67 1.67 0 01.383-3.3h2.116a1.675 1.675 0 010 3.35h-.582a1.275 1.275 0 00-.124.529 1.234 1.234 0 00.084.441h.622a2.645 2.645 0 000-5.289z",
    fill: "url(#virtual-hubs_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.79 7.468a3.042 3.042 0 01.031.405 2.722 2.722 0 01-.058.577 1.671 1.671 0 01-.383 3.3H9.264a1.675 1.675 0 010-3.35h.582a1.195 1.195 0 00.04-.97h-.622a2.645 2.645 0 000 5.289h2.116a2.644 2.644 0 00.41-5.253z",
    fill: "url(#virtual-hubs_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9-.025l-7.85 4.49v8.97L9 17.975l7.85-4.49v-9zm6.4 12.57l-6.4 3.7-6.4-3.661V5.355l6.4-3.7 6.4 3.71z",
    fill: "#0078d4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#virtual-hubs_svg__c)",
    d: "M9 0L1.15 4.49l1.45.89L9 1.68l6.4 3.7 1.45-.89L9 0z"
  })));
}
export default "data:image/svg+xml;base64,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";
export { SvgVirtualHubs as ReactComponent };